export default "__VITE_ASSET__BYvPbHvc__"